import Vue from 'vue';

const storeRecording = (state, { interactionId, callbackRecordingFile, callbackRecordingTranscription }) => {
  // eslint-disable-next-line import/no-named-as-default-member
  Vue.set(state.recordingsByInteractionId, interactionId, {
    callbackRecordingFile,
    callbackRecordingTranscription
  });
};

const setCallRecordingState = (state, { interactionId, isRecording, isPaused }) => {
  // eslint-disable-next-line import/no-named-as-default-member
  Vue.set(state.callRecordingStateByInteractionId, interactionId, { isRecording, isPaused });
};

const setCallRecordingIsRecording = (state, { interactionId, isRecording }) => {
  if (!state.callRecordingStateByInteractionId[interactionId]) {
    state.callRecordingStateByInteractionId[interactionId] = { isRecording };
  } else {
    state.callRecordingStateByInteractionId[interactionId].isRecording = isRecording;
  }
};

const setCallRecordingIsPaused = (state, { interactionId, isPaused }) => {
  if (!state.callRecordingStateByInteractionId[interactionId]) {
    state.callRecordingStateByInteractionId[interactionId] = { isPaused };
  } else {
    state.callRecordingStateByInteractionId[interactionId].isPaused = isPaused;
  }
};

const deleteRecording = (state, interactionId) => {
  delete state.recordingsByInteractionId[interactionId];
};

const deleteCallRecordingState = (state, interactionId) => {
  delete state.callRecordingStateByInteractionId[interactionId];
};

export default {
  setCallRecordingState,
  setCallRecordingIsRecording,
  setCallRecordingIsPaused,
  storeRecording,
  deleteRecording,
  deleteCallRecordingState
};
